module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-BlackOblique.00051b1d.woff";